import { usePermissions } from "components/context/permissionsContext";

export const useSettingPermission = () => {
  const { userPermissions } = usePermissions();

  // Role Permissions
  const hasRoleSavePermission = userPermissions.some(
    (item) =>
      item.module === "Settings" &&
      item.controller === "Role" &&
      item.action === "Save" &&
      item.hasPermission
  );
  const hasRoleGetPermission = userPermissions.some(
    (item) =>
      item.module === "Settings" &&
      item.controller === "Role" &&
      item.action === "Get" &&
      item.hasPermission
  );
  const hasRoleDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Settings" &&
      item.controller === "Role" &&
      item.action === "Delete" &&
      item.hasPermission
  );
  const hasRolePermsGetPermission = userPermissions.some(
    (item) =>
      item.module === "Settings" &&
      item.controller === "Role" &&
      item.action === "Get" &&
      item.identifier === "role-getpermissions" &&
      item.hasPermission
  );

  // Team Permissions
  const hasTeamSavePermission = userPermissions.some(
    (item) =>
      item.module === "Settings" &&
      item.controller === "Team" &&
      item.action === "Save" &&
      item.hasPermission
  );
  const hasTeamGetPermission = userPermissions.some(
    (item) =>
      item.module === "Settings" &&
      item.controller === "Team" &&
      item.action === "Get" &&
      item.hasPermission
  );
  // Stripe Permissions
  const hasStripeGetPermission = userPermissions.some(
    (item) =>
      item.module === "Settings" &&
      item.controller === "Stripe" &&
      item.action === "Get" &&
      item.hasPermission
  );
  const hasTeamDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Settings" &&
      item.controller === "Team" &&
      item.action === "Delete" &&
      item.hasPermission
  );

  // Skill Permissions
  const hasSkillSavePermission = userPermissions.some(
    (item) =>
      item.module === "Settings" &&
      item.controller === "Skills" &&
      item.action === "Save" &&
      item.hasPermission
  );
  const hasSkillGetPermission = userPermissions.some(
    (item) =>
      item.module === "Settings" &&
      item.controller === "Skills" &&
      item.action === "Get" &&
      item.hasPermission
  );
  const hasSkillDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Settings" &&
      item.controller === "Skills" &&
      item.action === "Delete" &&
      item.hasPermission
  );
  const hasSkillSoftDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Settings" &&
      item.controller === "Skills" &&
      item.action === "SoftDelete" &&
      item.hasPermission
  );

  // CompanySettings Permissions
  const hasCompanySavePermission = userPermissions.some(
    (item) =>
      item.module === "Settings" &&
      item.controller === "CompanySettings" &&
      item.action === "Save" &&
      item.hasPermission
  );
  const hasCompanyGetPermission = userPermissions.some(
    (item) =>
      item.module === "Settings" &&
      item.controller === "CompanySettings" &&
      item.action === "Get" &&
      item.hasPermission
  );

  // Sales Tax Permissions
  const hasSalesTaxSavePermission = userPermissions.some(
    (item) =>
      item.module === "Settings" &&
      item.controller === "CompanySettings" &&
      item.action === "SaveSalesTax" &&
      item.hasPermission
  );
  const hasSalesTaxGetPermission = userPermissions.some(
    (item) =>
      item.module === "Settings" &&
      item.controller === "CompanySettings" &&
      item.action === "GetSalesTax" &&
      item.hasPermission
  );
  const hasSalesTaxDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Settings" &&
      item.controller === "CompanySettings" &&
      item.action === "DeleteSalesTax" &&
      item.hasPermission
  );

  // TermsAndConditions Permissions
  const hasTnCSavePermission = userPermissions.some(
    (item) =>
      item.module === "Settings" &&
      item.controller === "TermsAndConditions" &&
      item.action === "Save" &&
      item.hasPermission
  );
  const hasTnCGetPermission = userPermissions.some(
    (item) =>
      item.module === "Settings" &&
      item.controller === "TermsAndConditions" &&
      item.action === "Get" &&
      item.hasPermission
  );
  const hasTnCDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Settings" &&
      item.controller === "TermsAndConditions" &&
      item.action === "Delete" &&
      item.hasPermission
  );

  // Industry Permissions
  const hasIndustrySavePermission = userPermissions.some(
    (item) =>
      item.module === "Settings" &&
      item.controller === "Service" &&
      item.identifier === "service-saveindustry" &&
      item.hasPermission
  );
  const hasIndustryGetPermission = userPermissions.some(
    (item) =>
      item.module === "Services" &&
      item.controller === "Service" &&
      item.identifier === "service-getindustries" &&
      item.hasPermission
  );
  const hasIndustryDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Settings" &&
      item.controller === "Service" &&
      item.identifier === "service-deleteindustry" &&
      item.hasPermission
  );

// Department Permissions
 const hasDepartmentSavePermission = userPermissions.some(
    (item) => 
      item.module === "Employee" &&
      item.controller === "Employee" &&
      item.action === "SaveDepartment" &&
      item.hasPermission
  );
  const hasDepartmentGetPermission = userPermissions.some(
    (item) => 
      item.module === "Employee" &&
      item.controller === "Employee" &&
      item.action === "GetDepartments" &&
      item.hasPermission
  );
  const hasDepartmentDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Employee" &&
      item.controller === "Employee" &&
      item.action === "DeleteDepartment" &&
      item.hasPermission
  );
  //Job Title
  const hasJobTitleSavePermission = userPermissions.some(
    (item) =>
      item.module === "Employee" &&
      item.controller === "Employee" &&
      item.action === "SaveJobTitle" &&
      item.hasPermission
  );
  const hasJobTitleGetPermission = userPermissions.some(
    (item) =>
      item.module === "Employee" &&
      item.controller === "Employee" &&
      item.action === "GetJobTitles" &&
      item.hasPermission
  );
  const hasJobTitleDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Employee" &&
      item.controller === "Employee" &&
      item.action === "DeleteJobTitle" &&
      item.hasPermission
  );

  // Unit of measure
  const hasUOMSavePermission = userPermissions.some(
    (item) =>
      item.module === "Settings" &&
      item.controller === "Material" &&
      item.action === "SaveUnit" &&
      item.hasPermission
  );
  const hasUOMGetPermission = userPermissions.some(
    (item) =>
      item.module === "Settings" &&
      item.controller === "Material" && 
      item.action === "GetUnits" &&
      item.hasPermission
  );
  const hasUOMDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Settings" &&
      item.controller === "Material" &&
      item.action === "DeleteUnit" &&
      item.hasPermission
  );
  const SettingPermissionProps = {
    // Role Permissions
    hasRoleSavePermission,
    hasRoleGetPermission,
    hasRoleDeletePermission,
    hasRolePermsGetPermission,

    // Team Permissions
    hasTeamSavePermission,
    hasTeamGetPermission,
    hasTeamDeletePermission,

    // Skill Permissions
    hasSkillSavePermission,
    hasSkillGetPermission,
    hasSkillDeletePermission,
    hasSkillSoftDeletePermission,

    // CompanySettings Permissions
    hasCompanySavePermission,
    hasCompanyGetPermission,

    // Sales Tax Permissions
    hasSalesTaxSavePermission,
    hasSalesTaxGetPermission,
    hasSalesTaxDeletePermission,

    // TermsAndConditions Permissions
    hasTnCSavePermission,
    hasTnCGetPermission,
    hasTnCDeletePermission,

    // Industry Permissions
    hasIndustrySavePermission,
    hasIndustryGetPermission,
    hasIndustryDeletePermission,

    // Department Permissions
    hasDepartmentSavePermission,
    hasDepartmentGetPermission,
    hasDepartmentDeletePermission,

    // Job Title Permissions
    hasJobTitleSavePermission,
    hasJobTitleGetPermission,
    hasJobTitleDeletePermission,

    // Unit of measure Permissions
    hasUOMSavePermission,
    hasUOMGetPermission,
    hasUOMDeletePermission,
  };

  return {
    SettingPermissionProps,
  };
};
